(function () {
  'use strict';

  angular
    .module('localization')
    .config(config);

  function config($translateProvider) {

    var data = {
      invest:{
        "signInvestment": "Sign investment",
        "headerNew":"New investment",
        "accountFrom":"From account",
        "amountInputLabel":"Amount",
        "quantityInputLabel": "Quantity",
        "accountTo":"Account to",
        "date":"Validation date",
        "dueDate": "Investment date",
        "dateNewOrder": "Investment date",
        "amountPlaceholder": "eg. 1,000.00",
        "accountType":"Account type",
        "fundName":"Fund name",
        "fundNameReplace": "Fund for replacement",
        "comment":"Comment",
        "bellowComment":"The applicant confirms to be familiar with ",
        "bellowComment2": "the brochure, rules and key information on fund investors",
        "bellowComment3": " and fully accepts all documents.",
        "investor":"Investor",
        "loan":"Loan",
        "buyingFond": "Buying fond",
        "sellingFond": "Selling fond",
        "replacementFond": "Replacement fond",
        "note": "Comment",
        "back": "Back",
        "amountMinAmountError": "Incorrect investment amount.",
        "amountMinAmountError2" : "Minimum amount of investment for the selected fund is 100.00 Kn.",
        "buyInvestmentPopup1": "This transaction opens a new account in the fund {{invFund}}",
        "buyInvestmentPopup2": "Do you want to continue?",
        "add":"Potvrdi",
        "alertInfoNoFund": "There is no available fund for selected account.",
        "amountTypeAllShares": "All shares",
        "amountTypeShareValue": "Share value",
        "amountTypeShareQuantity": "Share quantity",
        "accounts": "Accounts"
      },
      investOverview: {
        "totalShareValue": "Total share value",
        "shareQuantity": "Share quantity",
        "buyStocks": "Buy stocks",
        "sellStocks": "Sell stocks",
        "replaceStocks": "Replace stocks",
        "transactions": "Transactions",
        "orders": "Orders",
        "sharedAccount": "Shared account:",
        "invAmount": "Investment amount:",
        "invDate": "investment date:",
        "buyAccount": "Buy account:",
        "fundName": "Fund name:",
        "noTransactionData": "No transaction data.",
        "noOrderData": "No order data.",
        "shareAccount": "Share account",
        "dateOfEntry": "Date of entry",
        "shareValue": "Share value",
        "shareQuant": "Share quantity",
        "chargeValue": "Charge value",
        "fundType": "Fund type",
        "sharePrice": "Unit price",
        "copyOrder": "Copy order",
        "editOrder": "Edit order",
        "deleteOrder": "Delete order",
        "signOrder": "Sign order",
        "status_created": "Created",
        "status_recalled": "Recalled",
        "status_processed": "Processed",
        "status_rejected": "Rejected",
        "status_closed": "Closed",
        "status_signed": "Signed",
        "status_inProcess": "In Process",
        "status_canceled": "Canceled"
      },
      investmentsList: {
        "invOverview": "Investments overview",
        "shareQuantity": "Share quantity"
      },
      accessInvestment: {
        "accession": "Investment fund application form",
        "nameSurname": "Name and surname",
        "address": "Permanent residence address",
        "identificationNumber": "Number of identification documents",
        "issuer": "Issuer",
        "phone": "Phone",
        "emailNotification": "Slanje obavjesti E-mailom",
        "bank": "Bank",
        "paymentAccNumber": "Account number",
        "plannedYearInvestment": "Planned annual investments",
        "fundsInvestment": "Investment funds are realised from",
        "msg1": "By signing this Questionnaire I am confirming that all data in it are accurate and I am authorising the company Addiko-Invest d.d. (further: Company) to check the data mentioned here." +
        " I will personally inform you about any changes of the afore mentioned data and details.",
        "msg2": "By signing this Questionnaire I am authorising the Company to undertake all actions related to the processing and exchange of my personal data stated in the Questionnaire, including the information about the personal ID. These actions include collecting, storing, recording, organising, access and transfer of personal data for the purpose of conducting regular business operations of the Company.",
        "employee": "Employee",
        "firm": "Entrepreneur",
        "unemployed": "Unemployed",
        "retired": "Retired",
        "student": "Student",
        "rest": "Other",
        "personalStatus": "Personal status",
        "employer": "Type of employer",
        "privateSector": "Private sector",
        "civileService": "Civile service",
        "stateAuth": "State/regional authorities",
        "emplTrade": "State-owned companies",
        "vocation": "Vocation",
        "profession": "Profession",
        "invEmployment": "Employment",
        "invfreelancing": "Freelancing",
        "invLegal": "Ownership and ownership rights",
        "capital": "Capital",
        "invInsured": "Insurance",
        "inv1": "To 200.000 kn",
        "inv2": "To 500.000 kn",
        "inv3": "To 1.000.000 kn",
        "inv4": "More than 1.000.000 kn",
        "accountNumberInput": "Account number",
        "add": "Add"
      },
      salesReplacementTranslation: {
        title: "Business with investment funds"
      }
    };

    $translateProvider
      .translations('en', data);

  }
}());
